import Store from '../store/store'

export default class Collection {
    static make(collectionData) {
        let collection = new Collection();

        for (var i in collectionData) {
            collection[i] = collectionData[i];
        }

        if (collection.items) {
            for (var i = 0; i < collection.items.length; i++) {
                collection.items[i].music_item.getType = function() {
                    return this.polymorphicType
                }
            }
        }

        collection.user = Store.state.user;

        return collection;
    }

    static makeArray(collectionsData) {
        let collections = [];

        for (var i in collectionsData) {
            collections.push(Collection.make(collectionsData[i]))
        }

        return collections;
    }

    image (size = 100) {
        if (this.artwork && this.artwork.files) {
            return this.artwork.files[size]
        }
        return this.user.avatar.files[size]
    }

    getType() {
        return 'collection';
    }

    minPrice () {
        return this.price;
    }

    maxPrice () {
        return this.price;
    }

    isBeat () {
        return false;
    }

    isSong () {
        return false;
    }

    isSoundKit () {
        return false;
    }

    isCollection () {
        return true;
    }
}